import { useSelector } from "react-redux";

import { ComponentMyStatePage } from "@components";
import { selectAuth } from "@redux";


export const PageMyStatePage = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentMyStatePage
            memberTier={memberTier} avatar={""} fullName={""} socials={[]} />
    );
};
